var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"view-history"},[(_vm.data.length)?_c('history-list',{attrs:{"data":_vm.data}}):_c('h2',{staticClass:"view-history__empty-text",domProps:{"textContent":_vm._s(_vm.emptyText)}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }